module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/outline-icons-f89ea91ecd1ca2db7e09baa2c4b156d1.woff";